export function publicEstimateSearch(search: Record<string, unknown>) {
  return {
    deposit:
      search.deposit === 'success' || search.deposit === 'cancel'
        ? (search.deposit as 'success' | 'cancel')
        : undefined,
    session_id:
      typeof search.session_id === 'string' &&
      /^cs_(test|live)_[a-zA-Z0-9]+$/.test(search.session_id)
        ? search.session_id
        : undefined,
  };
}
